import React from 'react';
import CheckboxList from '../../../CheckboxList/CheckboxList';
import { FilterData } from '../../../FilterForm/FilterForm';
import { FilterByListOfAvailableValues } from '../../../../types/types';

export type FilterMultiSelectValue = string[];

interface IFilterSelectProps {
  onChange: (filterData: FilterData) => void;
  filter: FilterByListOfAvailableValues;
  filterData?: FilterData;
}

export default function FilterMultiSelect({
  onChange,
  filter,
  filterData,
}: IFilterSelectProps) {
  const handleMultipleChange = (newVal: string) => {
    const oldVal: string[] = filterData?.values || [];
    const values = oldVal.includes(newVal)
      ? oldVal.filter((i) => i !== newVal)
      : [...oldVal, newVal];
    onChange({ id: filter.id, values: values });
  };

  return (
    <CheckboxList
      onChange={handleMultipleChange}
      items={filter.availableValues}
      values={filterData?.values || []}
    />
  );
}
